export default {
      id: "stop-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#stop-usage",
      toString: function () {
        return this.url;
      }
    }